import React, { useEffect } from 'react';
import clsx from 'clsx';
import _ from 'underscore';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Button, Card, CardHeader, CardContent, CardActions, Grid, Divider, TextField, colors } from '@mui/material';
import DatePicker from 'components/DatePicker/DatePicker';
import validate from 'validate.js';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { enqueueSnackbar } from 'actions';
import { ReportNR7AssessmentExport, SetFormState } from '../../actions/ReportNR7AssessmentActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const schema = {
	Sites: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	Start_Period: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	End_Period: {
		presence: { allowEmpty: false, message: 'is required' },
	}
};

const ReportNR7AssessmentForm = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.reportNRReducer.formState);

	useEffect(() => {
		const errors = validate(formState.values, schema);

		setFormState({
			...formState,
			isValid: !errors,
			errors: errors || {},
		});
	}, [formState.values]);

	const _handleChange = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});
	};

	const _handleDateChange = (value, name) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[name]: value,
			},
			touched: {
				...formState.touched,
				[name]: true,
			},
		});
	};

	const _hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));
	const user = useSelector(state => state.session.user);
	const _generate = () => {
		dispatch(ReportNR7AssessmentExport(formState.values, user.id));
	};

	return (
		<Card className={classes.content}>
			<CardContent>
				<Grid container spacing={1}>
					<Grid item md={8} xs={12}>
						<TextField
							fullWidth
							label="Site(s) List"
							name="Sites"
							onChange={_handleChange}
							value={formState.values.Sites}
							variant="outlined"
							error={_hasError('Sites')}
							helperText={
								_hasError('Sites') ? formState.errors.Sites[0] : 'Example: 10500,10501,10502'
							}
						/>
					</Grid>
					<Grid item md={2} xs={12}>
						<DatePicker
							label="Start Period Date"
							name="Start_Period"
							value={formState.values.Start_Period || null}
							onChange={(value) => _handleDateChange(value, 'Start_Period')}
							error={_hasError('Start_Period')}
							helperText={_hasError('Start_Period') ? formState.errors.Start_Period[0] : null}
						/>
					</Grid>
					<Grid item md={2} xs={12}>
						<DatePicker
							label="End Period Date"
							name="End_Period"
							value={formState.values.End_Period || null}
							onChange={(value) => _handleDateChange(value, 'End_Period')}
							error={_hasError('End_Period')}
							helperText={_hasError('End_Period') ? formState.errors.End_Period[0] : null}
						/>
					</Grid>
				</Grid>
			</CardContent>
			<Divider />
			<CardActions>
				<Button className={classes.generate} onClick={_generate} variant="contained" disabled={!formState.isValid}>Export</Button>
			</CardActions>
		</Card>
	);
};

export default ReportNR7AssessmentForm;
